import { User } from 'lib-shared-types-api';
import { call, delay, put, select, takeLatest } from 'redux-saga/effects';

import { AppState } from 'bootstrap.store';

import { actions as conversationActions } from '../actions/conversation';
import { timelineActions } from '../actions/timeline';
import * as timelineApi from '../api/timeline';

const { timelineGetRequest, timelineGetSucceeded, timelineGetFailed } =
  timelineActions;

const { conversationUpdateUser } = conversationActions;

export const timeline = [
  takeLatest(
    conversationUpdateUser.toString() as any,
    refetchTimelineOnUserUpdate,
  ),
  takeLatest(timelineGetRequest.toString() as any, fetchTimeline),
];

function* fetchTimeline(action: { payload: { requesterId: string } }) {
  try {
    const result = yield call(timelineApi.getTimeline, action.payload);
    yield put(
      timelineGetSucceeded({
        data: result.data,
        requesterId: action.payload.requesterId,
      }),
    );
  } catch (exception) {
    yield put(timelineGetFailed as any);
  }
}

function* refetchTimelineOnUserUpdate(action: { payload: { data: User } }) {
  try {
    const updatedUserId = action.payload.data.id;
    const getMetaConversation = (state: AppState) =>
      state.conversation.metaConversation;

    const metaConversation = yield select(getMetaConversation);

    if (
      !metaConversation ||
      metaConversation.conversation.requested_by !== updatedUserId
    ) {
      return;
    }

    // Delay the execution with 5 seconds to give the backend time to update all services
    yield delay(5000);

    const result = yield call(timelineApi.getTimeline, {
      requesterId: updatedUserId,
    });

    yield put(
      timelineGetSucceeded({
        data: result.data,
        requesterId: updatedUserId,
      }),
    );
  } catch (exception) {
    yield put(timelineGetFailed as any);
  }
}
